import {
  TypeRestriction,
  ListProducts,
  ListSports,
  ListWagerType,
} from '@/enums'
import {
  SportRestrictionObject,
  ValidationIdProductType,
} from '@/state/bonus-engine/models'

const useRestrictionsSportsTypes = () => {
  const getProductsInitValues = () => {
    const tempProds: SportRestrictionObject[] = []
    Object.values(ListProducts).forEach((value) => {
      if (Number.isNaN(Number(value))) {
        const item: SportRestrictionObject = {
          name: value.toString(),
          id: Number(
            Object.keys(ListProducts)[
              Object.values(ListProducts).indexOf(value.toString())
            ],
          ),
          isVisible: true,
        }
        tempProds.push(item)
      }
    })
    return tempProds
  }

  const getProductsDefaultValues = () => {
    const tempProds: ValidationIdProductType[] = []
    Object.values(ListProducts).forEach((value) => {
      if (Number.isNaN(Number(value))) {
        const item: ValidationIdProductType = {
          type: TypeRestriction.product,
          validationId: Number(
            Object.keys(ListProducts)[
              Object.values(ListProducts).indexOf(value.toString())
            ],
          ),
          action: value === 'SPORTS' ? 1 : 2,
        }
        tempProds.push(item)
      }
    })
    return tempProds
  }

  const wagersShowOptions = [ListWagerType.STRAIGHT_BET, ListWagerType.TEASER]

  const getWagerTypeInitValues = (hideElements?: boolean) => {
    const tempWagers: SportRestrictionObject[] = []
    Object.values(ListWagerType).forEach((value) => {
      if (Number.isNaN(Number(value))) {
        const id = Number(
          Object.keys(ListWagerType)[
            Object.values(ListWagerType).indexOf(value.toString())
          ],
        )

        const item: SportRestrictionObject = {
          name: value.toString(),
          id,
          isVisible: hideElements
            ? wagersShowOptions.includes(id)
              ? true
              : false
            : true,
        }
        tempWagers.push(item)
      }
    })
    return tempWagers
  }

  const getWagerTypeDefaultValues = (hideElements?: boolean) => {
    const tempProds: ValidationIdProductType[] = []
    Object.values(ListWagerType).forEach((value) => {
      if (Number.isNaN(Number(value))) {
        const validationId = Number(
          Object.keys(ListWagerType)[
            Object.values(ListWagerType).indexOf(value.toString())
          ],
        )

        const item: ValidationIdProductType = {
          type: TypeRestriction.wagerType,
          validationId,
          action: hideElements
            ? wagersShowOptions.includes(validationId)
              ? 1
              : 2
            : 1,
        }
        tempProds.push(item)
      }
    })
    return tempProds
  }

  const sportsHideByDefaultOption = [
    ListSports.ALLIANZ_GAME_LOTTERY,
    ListSports.ANGUILLA_LOTTERY,
    ListSports.SPORT_CAST,
    ListSports.MOBADOO,
    ListSports.COCKPIT,
    // ListSports.HORSES,
  ]

  const getSportInitValues = (hideElements?: boolean) => {
    const tempSports: SportRestrictionObject[] = []
    Object.values(ListSports).forEach((value) => {
      const id =
        Object.values(ListSports)[Object.values(ListSports).indexOf(value)]
      const item: SportRestrictionObject = {
        name: value.toString(),
        id,
        isVisible: hideElements
          ? sportsHideByDefaultOption.includes(id)
            ? false
            : true
          : true,
      }
      tempSports.push(item)
    })
    return tempSports
  }

  const getSportDefaultValues = (hideElements?: boolean) => {
    const tempProds: ValidationIdProductType[] = []
    Object.values(ListSports).forEach((value) => {
      const validationId =
        Object.values(ListSports)[Object.values(ListSports).indexOf(value)]
      const item: ValidationIdProductType = {
        type: TypeRestriction.sport,
        validationId,
        action: hideElements
          ? sportsHideByDefaultOption.includes(validationId)
            ? 2
            : 1
          : 1,
      }
      tempProds.push(item)
    })
    return tempProds
  }

  return {
    getProductsInitValues,
    getWagerTypeInitValues,
    getSportInitValues,
    getProductsDefaultValues,
    getSportDefaultValues,
    getWagerTypeDefaultValues,
  }
}

export default useRestrictionsSportsTypes
